import * as React from 'react';
import * as Redux from 'redux';
import { BaseButton, IBaseButtonProps } from './base/base-button';

export interface IPrimaryButtonProps extends IBaseButtonProps  {
    testID?: string;
}


export class PrimaryButton extends React.Component<IPrimaryButtonProps, any> {
    GetClassNames() {
        //Use any special custom classes + the styles specific to this button type
        let BUTTON_STYLE = " button-primary";
        var classes = this.props.customClasses + BUTTON_STYLE;
        return classes;
    }

    render() {
        return (
            
            <BaseButton
                id={this.props.id}
                isDisabled={this.props.isDisabled}
                buttonText={this.props.buttonText}
                onClick={this.props.onClick}
                customClasses={this.GetClassNames()}
                testID={this.props.testID} />
        );
    }
}